/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const pdfInvoices = {
  pdfFacturas: {
    featureNotEnabled:
      'Si no puede obtener facturas, asegúrese de que SAP Invoice y API for Facturas estén habilitados.',
    invoicesLoadingError:
      'Algo salió mal. No se pueden mostrar las facturas del pedido',
    invoicesTable: {
      header: 'Facturas',
      label: 'Facturas Table',
      invoiceId: 'Factura #',
      createdAt: 'Fecha',
      netAmount: 'Importe neto',
      totalAmount: 'Importe total',
      attachment: 'Descargar factura',
      download: 'Descargar',
      attachmentDescription: 'Descargar PDF para factura {{id}}.',
      noneFound: 'No se han encontrado facturas',
    },
    downloadPDFError: 'Algo salió mal. No se puede obtener el PDF de la factura.',
    sortBy: 'Ordenar por',
    sortFacturas: 'Ordenar facturas',
    sorts: {
      byCreatedAtAsc: 'Fecha Ascending',
      byCreatedAtDesc: 'Fecha Descendente',
      byInvoiceIdAsc: 'Número de factura ascendente',
      byInvoiceIdDesc: 'Número de factura descendente',
      byNetAmountAsc: 'Importe neto Ascending',
      byNetAmountDesc: 'Importe neto Descending',
      byTotalAmountAsc: 'Importe total Ascendente',
      byTotalAmountDesc: 'Importe total Descendente',
    },
  },
};
